export default __webpack_public_path__ + "static/media/None.064feba7.png";